import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeShareUser } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetShareUser(refetch: (() => void) | undefined) {
    const { isLoading, mutate } = useMutation({
        // poolship/update/ is a legacy view: a refusal (a bad count is 2051
        // since pwa#135) still comes back as HTTP 200, so the code is checked
        // here — otherwise a refused change toasted «با موفقیت».
        mutationFn: async (payload: IChangeShareSettingPayload) => {
            const data = await settingChangeShareUser(payload)
            if (typeof data?.code === 'number' && data.code !== 2050) {
                throw Object.assign(new Error('poolship update refused'), {
                    code: data.code,
                })
            }
            return data
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_shares_changed', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch && refetch()
            toast.success('تغییر سهم با موفقیت انجام شد')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'change_shares',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
                code: error?.code,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
